import { Injectable } from '@angular/core';
import { HttpRequestService } from '../_common/http-request.service';

@Injectable()
export class MailTemplateService {

    constructor(private http: HttpRequestService) {
    }

    gets(type) {
        return this.http.get(`mailTemplate?type=${type}`).map(res => {
            return res.json();
        });
    }

    save(model) {
        return this.http.put('mailTemplateSave', model).map(res => {
            return res.json();
        });
    }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/mail-template.service.ts